module.exports = __webpack_public_path__ + "img/milk.4e5989cd.jpg";